/**
 * Seed démo Supabase au premier login (tables vides, pas de blob métier).
 */
import { supabase, isSupabaseConfigured } from "./supabase";
import { INIT_CLIENTS, INIT_EVENTS, DEFAULT_TARIF } from "../constants";
import { INIT_PRODUCTS } from "../constants/products";
import { migrateProduct } from "../utils/productMigration";
import { migrateAllClients } from "../utils/clientProductMigration";
import { clientAppToDbRow, eventAppToDbRow, productAppToDbRow } from "../utils/supabaseRowMappers";
import { logger } from "../utils/logger";

/**
 * @param {string} coachId
 * @returns {Promise<boolean>} true si des lignes ont été insérées
 */
export async function seedDemoDataIfEmpty(coachId) {
  if (!isSupabaseConfigured() || !supabase || !coachId || coachId === "local-coach") return false;

  const { count, error: countErr } = await supabase
    .from("clients")
    .select("id", { count: "exact", head: true })
    .eq("coach_id", coachId);

  if (countErr) {
    logger.warn("[seedDemo] count clients", { detail: countErr.message || countErr });
    return false;
  }
  if (count > 0) return false;

  const products = INIT_PRODUCTS.map(migrateProduct);
  const clients = migrateAllClients(INIT_CLIENTS, products, DEFAULT_TARIF);

  const productRows = products.map((p) => productAppToDbRow(p, coachId)).filter(Boolean);
  const clientRows = clients.map((c) => clientAppToDbRow(c, coachId)).filter(Boolean);
  const eventRows = INIT_EVENTS.map((e) => eventAppToDbRow(e, coachId)).filter(Boolean);

  if (!productRows.length || !clientRows.length) return false;

  const { error: pe } = await supabase.from("products").insert(productRows);
  if (pe) {
    logger.warn("[seedDemo] products", { detail: pe.message || pe });
    return false;
  }
  const { error: ce } = await supabase.from("clients").insert(clientRows);
  if (ce) {
    logger.warn("[seedDemo] clients", { detail: ce.message || ce });
    return false;
  }
  if (eventRows.length > 0) {
    const { error: ee } = await supabase.from("events").insert(eventRows);
    if (ee) {
      logger.warn("[seedDemo] events", { detail: ee.message || ee });
      return false;
    }
  }
  return true;
}
